import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { clearGlobalFilterReducer } from "../../data/redux/slice/globalFiltersSlice";
import { logoutService } from "../../services/logoutService";
import secureStorage from "../../services/secureStorage";
import {
  AccountLogoutIcon,
  ApiDocRouteIcon,
  ClientIcon,
  CollectBotLogo,
  CommissionIcon,
  CustmerIcon,
  DashboardRouteIcon,
  NeokredLogo,
  ResellerIcon,
  RoleManagementIcon,
  SettlementIcon,
  TransactionIcon,
  UserApprovalMenuIcon,
  VanIcon,
} from "../../utility/constants/assetsManager";
import {
  colorFontRed,
  colorWhite,
  primaryColor,
  sidebarFontColor,
} from "../../utility/constants/colorManager";
import {
  SS_CLIENT_VERIFIED,
  SS_FIRST_NAME,
  SS_LAST_NAME,
  SS_ROLE,
  SS_USER_HASH_ID,
  SS_WHITELABELED,
  SS_WHITELISTED_LOGO,
} from "../../utility/constants/secureStorageManager";
import {
  ADMIN,
  ADMIN_USER,
  API_DOC_ACL,
  APPROVAL_ACL,
  CLIENT,
  CLIENTS_ACL,
  CLIENT_SETTLEMENT,
  COMMISSION_LIST_ACL,
  COUPON_SERVICE,
  DASHBOARD_ACL,
  FINANCE_CENTER_ACL,
  RESELLER,
  RESELLER_ACL,
  RISK_MANAGEMENT,
  ROLE_MANAGEMENT_ACL,
  ROLE_MANAGEMENT_ACL_OLD,
  SETTLEMENT_ACL,
  TRANSACTION_ACL,
  VAN_ACL,
  VAN_CUSTOMERS,
  VAN_CUSTOMER_DOWNLOAD,
  VAN_CUSTOMER_LIST,
  VAN_TRANSACTION_COUNT,
  VAN_TRANSACTION_DOWNLOAD,
  VAN_TRANSACTION_LIST,
  VAN_TRANSACTION_RATE,
  VAN_TRANSACTION_VOLUME,
} from "../../utility/constants/valueConstants";
import Avatar from "../components/ui_comps/Avatar";
import CustomSelect from "../components/main_comps/custom_select";
import { fetchClientSecretId } from "../../services/fetchListingData";

const Container = ({
  title,
  icon,
  currentTab,
  route = [],
  onClick,
  divStyle,
  titleStyle,
  dropdown,
  active,
  linkRequired = true,
}) => {
  return (
    <>
      {linkRequired ? (
        <NavLink
          to={route[0]}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            backgroundColor: route.includes(currentTab)
              ? primaryColor
              : "transparent",
            width: "95%",
            padding: "10px 15px",
            borderRadius: "0px 4px 4px 0px",
            boxSizing: "border-box",
            transition: "all 0.4s",
            textDecoration: "none",
          }}
        >
          <div
            style={{
              margin: "5px 0px",
              display: "flex",

              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              ...divStyle,
            }}
            onClick={onClick}
          >
            {icon}

            <p
              style={{
                fontSize: 14,
                color: route.includes(currentTab)
                  ? colorWhite
                  : sidebarFontColor,
                fontWeight: "400",
                ...titleStyle,
              }}
            >
              {title}
            </p>
          </div>
        </NavLink>
      ) : (
        <div
          style={{
            margin: "5px 0px",
            display: "flex",

            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            ...divStyle,
          }}
          onClick={onClick}
        >
          {icon}

          <p
            style={{
              fontSize: 14,
              color: route.includes(currentTab) ? colorWhite : sidebarFontColor,
              fontWeight: "400",
              ...titleStyle,
            }}
          >
            {title}
          </p>
        </div>
      )}
    </>
  );
};

function Layout({}) {
  const [currentRoute, setCurrentRoute] = useState(0);
  const [payoutAvailable, setPayoutAvailable] = useState(false);
  const [userName, setUserName] = useState("");
  const [role, setRole] = useState("");
  const [dropdown, setDropdown] = useState(false);
  const [active, setActive] = useState(false);
  const [verifiedImage, setVerifiedImage] = useState("");
  const [imageLogo, setImageLogo] = useState(false);
  const [whiteLabeledUser, setWhiteLabeledUser] = useState(false);

  const location = useLocation();
  const clientHashId = secureStorage.getItem(SS_USER_HASH_ID);

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const state = useSelector((state) => state.authSliceReducer.isAuthenticated);
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const whitelistedLogo = useSelector((state) => state.logoSlice.logo);
  const [clientDetails, setClientDetials] = useState({});


  const filterCriteria = {
    "serviceType": "PAYOUT",
    "serviceProviderName": "AXIS",
    "mechanism": "VAN",
    "industryType": "CORPORATE"
  };

  // Filter data based on the criteria
  const filteredData = clientSecret.filter(item => {
    console.log(item, "mapping");
    return (
      item.serviceType?.toUpperCase() === filterCriteria.serviceType &&
      item.serviceProviderName?.toUpperCase() === filterCriteria.serviceProviderName &&
      item.mechanism?.toUpperCase() === filterCriteria.mechanism &&
      item.industryType?.toUpperCase() === filterCriteria.industryType
    );
  });


  console.log("Filtered Data:", filteredData);


  const onClickLogout = () => {
    dispatch(logoutService());
    enqueueSnackbar("logged out successfully", {
      variant: "success",
    });
    navigate("/login");
  };

  const getUserDetails = async () => {
    const firstName = await secureStorage.getItem(SS_FIRST_NAME);
    const lastName = await secureStorage.getItem(SS_LAST_NAME);
    const role = await secureStorage.getItem(SS_ROLE);
    const isVerified = await secureStorage.getItem(SS_CLIENT_VERIFIED);

    if (isVerified) {
      setVerifiedImage(CollectBotLogo);
    } else setVerifiedImage(NeokredLogo);
    setUserName(firstName + " " + lastName);
    setRole(role?.toUpperCase());
  };

  const getClientProgram = () => {
    let payout = clientSecret.filter(
      (obj) =>
        obj.serviceType?.toUpperCase() === "PAYOUT" &&
        (obj.serviceProviderName?.toUpperCase() === "EQUITAS" ||
          obj.serviceProviderName?.toUpperCase() === "ESKAY")
    );
    if (payout.length > 0) {
      setClientDetials(payout);
    }
  };
 

  useEffect(() => {
    dispatch(clearGlobalFilterReducer());
    if (
      location.pathname === "/van/dashboard" ||
      location.pathname === "/van/transaction" ||
      location.pathname === "/van/customer"
    ) {
      setActive(true);
    } else {
      setActive(false);
      setDropdown(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (role === CLIENT) {
      getClientProgram();
    }
  }, [clientSecret]);

  useEffect(() => {
    if (whitelistedLogo) {
      setImageLogo(whitelistedLogo);
    }
  }, [whitelistedLogo]);

  useEffect(() => {
    if (role === CLIENT) {
      dispatch(fetchClientSecretId());
    }
    let payout = clientSecret.filter((obj) => obj.serviceType === "payout");
    if (payout?.length !== 0) {
      setPayoutAvailable(true);
    }
    getUserDetails();
  }, []);

  return (
    <div style={styles.mainContainerStyle} className="hide-scroll-bar">
      <div style={styles.container1}>
        <div style={styles.neokredLogoContainer}>
          <img
            src={imageLogo ? imageLogo : NeokredLogo}
            style={{
              objectFit: "contain",
              width: "160px",
              height: "80px",
            }}
            alt="Logo"
          />
        </div>
        <div style={styles.optionContainer}>
          {aclData.includes(DASHBOARD_ACL) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Dashboard"
              icon={
                <DashboardRouteIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "/dashboard"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/dashboard"]}
              currentTab={location.pathname}
            />
          )}
          {aclData.includes(TRANSACTION_ACL) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Transaction"
              icon={
                <TransactionIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "/transaction"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/transaction"]}
              currentTab={location.pathname}
            />
          )}{" "}
          {aclData.includes(VAN_CUSTOMERS) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Customers"
              icon={
                <ClientIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "/customer-list"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/customer-list"]}
              currentTab={location.pathname}
            />
          )}
          {aclData.includes(RESELLER_ACL) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Reseller"
              icon={
                <ResellerIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "/reseller" ||
                    location.pathname === "/reseller/details"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/reseller", "/reseller/details"]}
              currentTab={location.pathname}
            />
          )}
          {aclData.includes(COUPON_SERVICE) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Coupons"
              icon={
                <TransactionIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "/coupons" ||
                    location.pathname === "/"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/coupons"]}
              currentTab={location.pathname}
            />
          )}
          {aclData.includes(CLIENTS_ACL) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Clients"
              icon={
                <ClientIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "/clients" ||
                    location.pathname === "/clients/details"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/clients", "/clients/details"]}
              currentTab={location.pathname}
            />
          )}
          {aclData.includes(CLIENT_SETTLEMENT) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Client Settlement"
              icon={
                <SettlementIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "client-settlement"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/client-settlement"]}
              currentTab={location.pathname}
            />
          )}
          {aclData.includes(RISK_MANAGEMENT) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Risk Management"
              icon={
                <SettlementIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "risk-management"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/risk-management"]}
              currentTab={location.pathname}
            />
          )}
          {/* {aclData.includes(COMMISSION_LIST_ACL) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Commission List"
              icon={
                <CommissionIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "/commission"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/commission"]}
              currentTab={location.pathname}
            />
          )} */}
          {(aclData.includes(ROLE_MANAGEMENT_ACL) ||
            aclData.includes(ROLE_MANAGEMENT_ACL_OLD)) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Role Management"
              icon={
                <RoleManagementIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "/role-management" ||
                    location.pathname === "/role-management/details"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/role-management", "/role-management/details"]}
              currentTab={location.pathname}
            />
          )}
          {aclData.includes(APPROVAL_ACL) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Approval"
              icon={
                <UserApprovalMenuIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "/approval/list"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              currentTab={location.pathname}
              route={["/approval/list"]}
            />
          )}{" "}
          {aclData.includes(SETTLEMENT_ACL) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Finance Center"
              icon={
                <SettlementIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "/finance"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/finance"]}
              currentTab={location.pathname}
            />
          )}
          {aclData.includes(VAN_ACL) && (
            <Container
              onClick={() => {
                setDropdown(!dropdown);
                setActive(!active);
              }}
              title="VAN"
              icon={
                <VanIcon
                  style={styles.iconStyle}
                  fill={dropdown ? colorWhite : sidebarFontColor}
                />
              }
              titleStyle={{
                color: active ? "#FDFDFD" : "#6C6B6B",
              }}
              divStyle={{
                backgroundColor: active ? "#38369C" : "",
                ...styles.vandivStyle,
              }}
              linkRequired={false}
            />
          )}
          {dropdown && (
            <div style={{}}>
              {(aclData?.includes(VAN_TRANSACTION_COUNT) ||
                aclData?.includes(VAN_TRANSACTION_RATE) ||
                aclData?.includes(VAN_TRANSACTION_VOLUME)) && (
                <Container
                  title="Dashboard"
                  route={["/van/dashboard"]}
                  currentTab={location.pathname}
                  divStyle={{
                    ...styles.innerdivStyle,
                  }}
                />
              )}

              {(aclData?.includes(VAN_TRANSACTION_DOWNLOAD) ||
                aclData?.includes(VAN_TRANSACTION_LIST)) && (
                <Container
                  title="Transactions"
                  route={["/van/transaction"]}
                  currentTab={location.pathname}
                  divStyle={{
                    paddingLeft: "10px",
                    ...styles.innerdivStyle,
                  }}
                />
              )}

              {(aclData?.includes(VAN_CUSTOMER_LIST) ||
                aclData?.includes(VAN_CUSTOMER_DOWNLOAD)) && (
                <Container
                  title="Customer List"
                  route={["/van/customer"]}
                  currentTab={location.pathname}
                  divStyle={{
                    paddingLeft: "18px",
                    ...styles.innerdivStyle,
                  }}
                />
              )}
            </div>
          )}
          <Container
            onClick={(val) => {
              setCurrentRoute(val);
            }}
            title="Support"
            icon={
              <ClientIcon
                style={styles.iconStyle}
                fill={
                  location.pathname === "/support"
                    ? colorWhite
                    : sidebarFontColor
                }
              />
            }
            route={["/support"]}
            currentTab={location.pathname}
          />
          {aclData.includes(API_DOC_ACL) && (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
                setDropdown(false);
              }}
              title="API Doc"
              icon={
                <ApiDocRouteIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "/api-doc"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/api-doc"]}
              currentTab={location.pathname}
            />
          )}
          {(role === CLIENT && filteredData.length > 0) ? (
            <Container
              onClick={(val) => {
                setCurrentRoute(val);
              }}
              title="Customer Center"
              icon={
                <CustmerIcon
                  style={styles.iconStyle}
                  fill={
                    location.pathname === "/customer"
                      ? colorWhite
                      : sidebarFontColor
                  }
                />
              }
              route={["/customer"]}
              currentTab={location.pathname}
            />
          ) : null}
        </div>
      </div>
      <div style={styles.bottomContainer}>
        <div
          style={{
            width: "100%",
            height: "auto",
            display: "flex",
            alignItems: "center",
            height: 100,
          }}
        >
          <Avatar name={userName} size={40} />
          <div
            style={{
              padding: "0px 10px",
              textTransform: "capitalize",
            }}
          >
            <p style={{}}>{userName}</p>
            <p
              style={{
                fontSize: 13,
                color: sidebarFontColor,
              }}
            >
              {role}
            </p>
          </div>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={onClickLogout}
        >
          <AccountLogoutIcon
            style={{
              width: 20,
              height: 20,
              margin: "0px 10px",
            }}
          />
          <p
            style={{
              color: colorFontRed,
            }}
          >
            Logout
          </p>
        </div>
      </div>
    </div>
  );
}

const styles = {
  iconStyle: {
    width: 18,
    height: 18,
    margin: "0px 10px",
  },
  mainContainerStyle: {
    height: "100vh",
    boxSizing: "border-box",
    background: "#FFFFFF",
    borderRight: "1px solid #F3F3F3",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    minWidth: 160,
    maxWidth: 240,
    overflow: "scroll",
  },
  container1: {
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  neokredLogoContainer: {
    width: "100%",
    display: "flex",
    padding: "0px 25px",
    alignItems: "center",
    margin: "30px 0px",
  },
  optionContainer: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    flex: 1,
    gap: 20,
  },
  bottomContainer: {
    display: "flex",
    margin: "15px 15px",
    flexDirection: "column",
    padding: "10px 0px",
    borderTop: "1px solid #f3f3f3",
  },
  innerdivStyle: {
    borderRadius: "0px 6px 6px 0px",

    paddingRight: "50px",
    height: "22px",
    width: "205px",
    textAlign: "center",
  },
  vandivStyle: {
    display: "flex",
    flexDirection: "row-reverse",
    gap: "90px",
    padding: "12px 30px 12px 40px",
    marginLeft: "-15px",
    borderRadius: "0px 6px 6px 0px",
  },
};

export default Layout;
